import React, { useState, useEffect } from "react";
import { Input, Button, List } from "antd";

interface Entry {
  name: string;
  value: string;
}

interface DynamicInputsProps {
  data: Entry[];
  setData: (data: Entry[]) => void;
}

const DynamicInputs: React.FC<DynamicInputsProps> = ({ data, setData }) => {
  //   const [inputs, setInputs] = useState<Entry[]>(initialData);

  //   useEffect(() => {
  //     setData(inputs);
  //   }, [inputs, setData]);

  //   useEffect(() => {
  //     setInputs(initialData);
  //   }, []);

  const addNewInput = () => {
    setData([...data, { name: "", value: "" }]);
  };

  const handleChange = (index: number, field: keyof Entry, value: string) => {
    const newInputs = data.map((input, i) =>
      i === index ? { ...input, [field]: value } : input
    );
    setData(newInputs);
  };

  const removeInput = (index: number) => {
    const newInputs = data.filter((_, i) => i !== index);
    setData(newInputs);
  };

  return (
    <div style={{ margin: "auto" }}>
      {data.map((input, index) => (
        <div
          key={index}
          style={{
            marginBottom: 10,
            display: "flex",
            alignItems: "center",
            gap: 5,
            justifyContent: "space-between",
          }}
        >
          <Input
            placeholder="Nom du site"
            value={input.name}
            onChange={(e) => handleChange(index, "name", e.target.value)}
            style={{ flex: 1, height: 40 }}
          />
          <Input
            placeholder="Id du site"
            value={input.value}
            onChange={(e) => handleChange(index, "value", e.target.value)}
            style={{ flex: 3, height: 40 }}
          />
          <Button
            danger
            onClick={() => removeInput(index)}
            style={{ height: 38 }}
          >
            X
          </Button>
        </div>
      ))}
      <Button type="dashed" onClick={addNewInput} block>
        Ajouter un nouveau site
      </Button>
    </div>
  );
};

export default DynamicInputs;
